import classNames from 'classnames';
import { memo, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Dispatch } from 'redux';
import { ButtonGroup, Dropdown, InputNumber } from 'rsuite';
import { RootState } from '../../../../../@types/RootState';
import {
  selectorStockQuantityFilter,
  setStockQuantityIsActive,
  setStockQuantityValue,
  toggleStockQuantityIsActive,
} from '../../../../../reducers/gerenciadorPrecos/quickActionsFilter';
import { BaseQuickActionFilterProps, IconButton } from '../QuickActionFilter';
import quickActionFilterStyles from '../QuickActionFilter/elements/FilterPriceVariation.module.scss';

type StockQuantityFilterProps = RouteComponentProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

const StockQuantityFilter = memo(
  ({ stockQuantityFilter, setStockQuantityValue, setStockQuantityIsActive, toggleStockQuantityIsActive }: StockQuantityFilterProps) => {
    const [innerValue, setInnerValue] = useState(stockQuantityFilter.value ?? 0);

    useEffect(() => {
      if (typeof stockQuantityFilter.value === 'number') {
        setInnerValue(stockQuantityFilter.value);
      }
    }, [stockQuantityFilter.value]);

    const skinColor = useMemo<BaseQuickActionFilterProps['skin']>(() => {
      return stockQuantityFilter.isActive ? 'primary' : 'neutral';
    }, [stockQuantityFilter.isActive]);

    const handleClickToggle = () => {
      if (innerValue !== stockQuantityFilter.value) setStockQuantityValue(innerValue);
      toggleStockQuantityIsActive();
    };

    const handleChangeValue = (value: number | string) => {
      setInnerValue(Number(value));
    };

    const handleCloseDropdown = () => {
      setStockQuantityValue(innerValue);
      setStockQuantityIsActive(true);
    };

    return (
      <ButtonGroup className={classNames('quick-action-filter__button__container quick-action-filter__toggle', quickActionFilterStyles.container)}>
        <IconButton icon="MdPallet" skin={skinColor} onClick={handleClickToggle} placeholder="Filtrar por estoque" />
        <Dropdown
          activeKey="1"
          eventKey="1"
          placement="bottomEnd"
          renderTitle={() => <IconButton icon="MdKeyboardArrowDown" className="quick-action-filter__toggle__arrow" skin={skinColor} />}
          onClose={handleCloseDropdown}
          menuStyle={{ width: '282px' }}
        >
          <Dropdown.Item panel className="quick-action-filter__select-interval" style={{ ['--select-interval-padding' as string]: '12px' }}>
            <div className={'quick-action-filter__select-interval__dropdown-item'}>
              <p>Filtrar estoque maior que</p>
              <InputNumber min={0} value={innerValue} onChange={handleChangeValue} />
              <p>unidades</p>
            </div>
          </Dropdown.Item>
        </Dropdown>
      </ButtonGroup>
    );
  },
);

StockQuantityFilter.displayName = 'StockQuantityFilter';

const mapStateToProps = (state: RootState) => ({
  stockQuantityFilter: selectorStockQuantityFilter(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setStockQuantityValue: (value: number) => dispatch(setStockQuantityValue(value)),
  toggleStockQuantityIsActive: () => dispatch(toggleStockQuantityIsActive()),
  setStockQuantityIsActive: (payload: boolean) => dispatch(setStockQuantityIsActive(payload)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StockQuantityFilter));
